import { Payload } from "@neworbit/redux-helpers";
import { Dispatch } from "redux";
import axios from "axios";

import { loadAndTrack } from "redux-request-loading";

import { AllowedProductsApi } from "./AllowedProductsApi";
import * as actionTypes from "./actionTypes";

type LoadAllowedProductsSuccessAction = { type: typeof actionTypes.LOAD_ALLOWED_PRODUCTS_SUCCESS } & Payload<string[]>;

export type AllowedProductsAction = LoadAllowedProductsSuccessAction;

function buildLoadAllowedProducts(allowedProductsApi: AllowedProductsApi) {
    return () => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, actionTypes.LOAD_ALLOWED_PRODUCTS, allowedProductsApi.load());
            dispatch(loadAllowedProductsSuccess(result));
        };
    };
}

export const loadAllowedProducts = buildLoadAllowedProducts(new AllowedProductsApi(axios));

export function loadAllowedProductsSuccess(allowedProducts: string[]): LoadAllowedProductsSuccessAction {
    return {
        type: actionTypes.LOAD_ALLOWED_PRODUCTS_SUCCESS,
        payload: allowedProducts
    };
}
